import { SimpleAddress } from './checkoutState';

export type Coordinates = {
  latitude: number;
  longitude: number;
};

// Before using this function ensure that the google maps SDK has been loaded
export const geocode = async (address: string): Promise<Coordinates> => {
  const geocoder = new google.maps.Geocoder();
  const { results } = await geocoder.geocode({ address });
  const location = results[0].geometry.location;

  return {
    latitude: location.lat(),
    longitude: location.lng(),
  };
};

// Before using this function ensure that the google maps SDK has been loaded
export const reverseGeocode = async (coords: Coordinates): Promise<Partial<SimpleAddress>> => {
  const geocoder = new google.maps.Geocoder();
  const { results } = await geocoder.geocode({ location: { lat: coords.latitude, lng: coords.longitude } });

  const getAddressComponent = (type: string) =>
    results[0].address_components.find((component: { types: string | string[] }) => component.types.includes(type))
      ?.long_name;

  const street = getAddressComponent('route');
  const houseNumber = getAddressComponent('street_number');
  const zipCode = getAddressComponent('postal_code');
  const city = getAddressComponent('locality');

  return { street, houseNumber, zipCode, city };
};
